import { render } from "./DataProviderDetails.vue?vue&type=template&id=6b6afbb9&scoped=true"
import script from "./DataProviderDetails.vue?vue&type=script&lang=js"
export * from "./DataProviderDetails.vue?vue&type=script&lang=js"

import "./DataProviderDetails.vue?vue&type=style&index=0&id=6b6afbb9&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6afbb9"]])

export default __exports__